// extracted by mini-css-extract-plugin
export default {"contentwithsidebarwrapper":"AppWithSidebarWrapper-module--contentwithsidebarwrapper--31798"};